import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import Tickets from '../components/tickets';
import Answers from '../components/answers';
import CloseForm from '../components/close-form/main';

import { selectors as rootSelectors } from '../../root';

const Main = renderViewsState(
	props => (
		<Animate>
			{props.closeFormShouldShowStatus && (
				<CloseForm
					{...props}
					validate={props.closeFormValidate}
					enableReinitialize={true}
					initialValues={props.closeFormInitialValues}
				/>
			)}
			<div className="container__content ext-thread">
				<div className="container__content-body">
					<div className="support">
						<div className="position__tickets">
							<Tickets {...props} />
						</div>
						<div className="position__answers">
							<Answers {...props} />
						</div>

					</div>
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		threadStatusesList: selectors.getThreadStatusesList(state),
		ticketsList: selectors.getTicketsList(state),
		answerFormInitialValues: selectors.getAnswerFormInitialValues(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		progressBar: selectors.getProgressBar(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		closeFormInitialValues: selectors.getCloseFormInitialValues(state),
		closeFormShouldShowStatus: selectors.getCloseFormShouldShowStatus(state),
		closeFormValidate: selectors.getCloseFormValidate(state),
		timezone: selectors.getAdminTimezone(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/external-threads/item/main.js